/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from "@/shared/api/axiosInstance";
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from "@/shared/api/axiosInstance";
import type {
  GetApiV1SerieSerieidLangsAvailableLanguagesQueryResponse,
  GetApiV1SerieSerieidLangsAvailableLanguagesPathParams,
  GetApiV1SerieSerieidLangsAvailableLanguages401,
  GetApiV1SerieSerieidLangsAvailableLanguages404,
  GetApiV1SerieSerieidLangsAvailableLanguages500,
} from "../../types/serieIdiomasController/GetApiV1SerieSerieidLangsAvailableLanguages.ts";

function getGetApiV1SerieSerieidLangsAvailableLanguagesUrl(
  serieId: GetApiV1SerieSerieidLangsAvailableLanguagesPathParams["serieId"],
) {
  const res = {
    method: "GET",
    url: `/api/v1/serie/${serieId}/langs/available-languages` as const,
  };
  return res;
}

/**
 * @description Retorna os idiomas ainda não cadastrados para a série, para dropdown. **(Requer Authorization para autenticação)**
 * @summary Idiomas disponíveis (Requer Authorization para autenticação)
 * {@link /api/v1/serie/:serieId/langs/available-languages}
 */
export async function getApiV1SerieSerieidLangsAvailableLanguages(
  serieId: GetApiV1SerieSerieidLangsAvailableLanguagesPathParams["serieId"],
  config: Partial<RequestConfig> & { client?: Client } = {},
) {
  const { client: request = fetch, ...requestConfig } = config;

  const res = await request<
    GetApiV1SerieSerieidLangsAvailableLanguagesQueryResponse,
    ResponseErrorConfig<
      | GetApiV1SerieSerieidLangsAvailableLanguages401
      | GetApiV1SerieSerieidLangsAvailableLanguages404
      | GetApiV1SerieSerieidLangsAvailableLanguages500
    >,
    unknown
  >({
    method: "GET",
    url: getGetApiV1SerieSerieidLangsAvailableLanguagesUrl(
      serieId,
    ).url.toString(),
    ...requestConfig,
  });
  return res.data;
}
